import createAxios from "./axiosHttp";

function getRoutes(pagination, query, sort) {
  const axios = createAxios();
  const urlPath = "ttmm/route/ql";
  return axios.post(urlPath, { pagination, query, sort });
}
function exportar(pagination, query, sort) {
  const axios = createAxios();
  const urlPath = "ttmm/route/ql/export";
  return axios.post(
    urlPath,
    { pagination, query, sort },
    { responseType: "arraybuffer" }
  );
}

function getRouteById(routeId) {
  const axios = createAxios();
  const urlPath = `ttmm/route/${routeId}`;
  return axios.get(urlPath);
}

function getRoutesByPlanId(planId) {
  const axios = createAxios();
  const urlPath = `ttmm/route/plan/${planId}`;
  return axios.get(urlPath);
}

export const routeService = {
  getRoutes,
  exportar,
  getRouteById,
  getRoutesByPlanId,
};
